import { isEmpty } from 'underscore';

export function validateText(text = '', maxCharCount, i18n, validator, isRequired) {
  if (isRequired) {
    if (isEmpty(text.trim())) {
      return {
        charRemainingDescription: maxCharCount ? i18n.getString(_TL_('{{maxCharCount}} characters remaining'), { maxCharCount }) : '',
        errorMessage: 'Field should not be empty',
      };
    }
  }

  if (maxCharCount) {
    const usedCharCount = text ? text.length : 0;
    const remainingCharCount = maxCharCount - usedCharCount;
    if (remainingCharCount >= 0) {
      return {
        charRemainingDescription: i18n.getString(_TL_('{{remainingCharCount}} characters remaining'), { remainingCharCount }),
        errorMessage: '',
      };
    }

    return {
      charRemainingDescription: i18n.getString(_TL_('Exceeded by {{-remainingCharCount}} characters'), { remainingCharCount }),
      errorMessage: i18n.getString(_TL_('Field should not exceed {{maxCharCount}} characters'), { maxCharCount }),
    };
  }

  if (validator) {
    return {
      charRemainingDescription: '',
      errorMessage: validator(text),
    };
  }

  return {
    charRemainingDescription: '',
    errorMessage: '',
  };
}
